import { render, staticRenderFns } from "./ln-form-textarea.vue?vue&type=template&id=077c5e2a&"
import script from "./ln-form-textarea.vue?vue&type=script&lang=js&"
export * from "./ln-form-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports